import React, { useState, useEffect } from "react";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import Preloader from "./preloader";

const Layout = ({ children }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Check if preloader has been shown before (stored in sessionStorage)
    const hasPreloaderShown = sessionStorage.getItem("hasPreloaderShown");

    // Show preloader only on the first load of the application or page refresh
    if (!hasPreloaderShown) {
      setLoading(true); // Show preloader
      sessionStorage.setItem("hasPreloaderShown", "true"); // Save flag in sessionStorage
    }
  }, []);

  // Ensure sessionStorage is cleared when the tab is closed
  useEffect(() => {
    const clearSessionOnTabClose = () => {
      sessionStorage.removeItem("hasPreloaderShown");
    };

    window.addEventListener("beforeunload", clearSessionOnTabClose);

    return () => {
      window.removeEventListener("beforeunload", clearSessionOnTabClose);
    };
  }, []);

  return (
    <>
      {/* Show Preloader only on first visit or after refresh */}
      {loading ? (
        <Preloader setLoading={setLoading} />
      ) : (
        <div>
          <Header />
          <main>{children}</main>
          <Footer />
        </div>
      )}
    </>
  );
};

export default Layout;
